module.exports = __webpack_public_path__ + "static/media/hartali.c927fbed.png";